import MAV from '@/api/mav';
import { isShadowMode } from '@/helpers/mavModeDetection';
import { generateRequestId } from '@/helpers/shadowModeTracking';

/**
 * Fire-and-forget shadow evaluation for a single domain rule.
 * @param {Object} params
 * @param {string} params.domain
 * @param {number} params.expectedTreeId
 * @param {string} params.source
 * @param {string} [params.userEmail]
 */
export function sendDomainShadowEvaluation({ domain, expectedTreeId, source, userEmail }) {
  if (!isShadowMode() || !domain || expectedTreeId == null) {
    return Promise.resolve();
  }

  const requestId = generateRequestId();

  return MAV.post(
    '/shadow/tree/domain',
    {
      domain,
      expected_tree_id: expectedTreeId,
    },
    {
      headers: {
        'X-Shadow-Request-Id': requestId,
        'X-Shadow-Source': source,
        'X-User-Email': userEmail || 'unknown',
      },
    },
  ).catch(error => {
    console.error('[Domain Shadow API] Evaluation failed:', { domain, error });
  });
}

/**
 * Parallel shadow evaluations for multiple domain rules (bulk add).
 * @param {string[]} domains
 * @param {number} expectedTreeId
 * @param {Object} options
 * @param {string} options.source
 * @param {string} [options.userEmail]
 */
export function sendDomainShadowEvaluations(domains, expectedTreeId, { source, userEmail }) {
  const uniqueDomains = [...new Set(domains.filter(Boolean))];

  return Promise.allSettled(
    uniqueDomains.map(domain =>
      sendDomainShadowEvaluation({
        domain,
        expectedTreeId,
        source,
        userEmail,
      }),
    ),
  );
}
